module.exports = __webpack_public_path__ + "static/media/A4.5875fd69.mp3";